<ion-icon name="info-filled" [id]="trigger"></ion-icon>
<ion-popover [trigger]="trigger" triggerAction="click">
  <ng-template>
    <ion-content>
      <ion-icon name="close" (click)="dismiss()"></ion-icon>
      <ng-content></ng-content>
    </ion-content>
  </ng-template>
</ion-popover>
